import styled from 'styled-components';

export const Container = styled.div`
  border: 1px solid #ced4da;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 16px;

  &.clickable {
    cursor: pointer;
  }

  &.clickable:hover {
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
  }

  .featured-thumb {
    position: relative;
    width: 100%;
    padding-top: 38%;
    background: #01080c center/cover no-repeat;
    border-radius: 6px;
    overflow: hidden;
    margin-bottom: 16px;
  }

  .featured-thumb img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .featured-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 6px;
  }

  .featured-title {
    font-size: 1.15rem;
    font-weight: 600;
    color: #000;
    min-width: 0;
  }

  .featured-action {
    flex-shrink: 0;
  }

  .featured-date {
    font-size: 0.9rem;
    font-weight: 400;
    color: #000;
    margin-bottom: 8px;
  }

  .countdown {
    display: inline-block;
    background: #28a745;
    color: #fff;
    font-size: 0.7rem;
    font-weight: 700;
    padding: 2px 7px;
    border-radius: 4px;
  }

  @media (max-width: 576px) {
    .featured-head {
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
    }
  }
`;
